import { render, staticRenderFns } from "./TeamplannerResponsesSummaryCard.vue?vue&type=template&id=1f924e67"
import script from "./TeamplannerResponsesSummaryCard.vue?vue&type=script&lang=js"
export * from "./TeamplannerResponsesSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports